import { Typography } from "@mui/material";
import { memo } from "react";
import { StyledContainer } from "./Footer.styles";

const Footer = () => (
  <StyledContainer>
    <Typography variant="caption" sx={{ fontSize: "12px", lineHeight: "1.5" }}>
      © NANI BOOK ENTERPRISE CO., LTD. All Rights Reserved.
    </Typography>
  </StyledContainer>
);

export default memo(Footer);
